import {useModalStore} from "@/Stores/Site/ModalStore";
import {Button} from "@/shared/ui/Button";
import {useLoginOrRegistrationModalStore} from "@/widgets/login-or-registration-modal";

type Props = {
    productId: number;
    reviewAdd: boolean;
    authCheck: boolean;
    className?: string;
};

export const AddReviewButton = ({productId, reviewAdd, authCheck, className}: Props) => {
    const openModal = useLoginOrRegistrationModalStore(s => s.actions.openModal);
    const openModalWriteReview = useModalStore(state => state.openModalWriteReview);

    const onClickButton = () => {
        if (!authCheck) {
            openModal();
        } else {
            openModalWriteReview(productId);
        }
    }

    if (!reviewAdd) {
        return null;
    }

    return (
        <Button className={className} onClick={onClickButton}>Оставить отзыв</Button>
    );
}
